import React, { FC, useEffect, useState } from 'react';
import SupportContent from '@srm/ui/support-content';
import AnchoredDialog from '@srm/ui/anchored-dialog';
import { TechSupportService } from '@services/TechSupportService';
import { useScreenShareContext } from '@providers/ScreenShareProvider/ScreenShareContext';
import SupportScreenShareStart from './SupportScreenShareStart';
import { REMOTE_CONTROL_EXCLUDE_CLASS } from '@srm/screen-sharing/light';
import './SupportDialog.scss';

export interface ISupportDialogProps {
    /** Кнопка-якорь (Popover.Target). */
    target: React.ReactNode;
    opened: boolean;
    onClose: () => void;
}

const SupportDialog: FC<ISupportDialogProps> = ({ target, opened, onClose }) => {
    const [textInfo, setTextInfo] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const screenShare = useScreenShareContext();

    useEffect(() => {
        if (!opened || textInfo || isLoading) {
            return;
        }

        setIsLoading(true);

        TechSupportService.getTextInfo()
            .then((value) => {
                setTextInfo(value.data);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [isLoading, opened, textInfo]);

    return (
        <AnchoredDialog
            align="right"
            target={target}
            // Окно — портал вне обёртки меню: исключено из удалённого управления само.
            className={`rf-support-dialog ${REMOTE_CONTROL_EXCLUDE_CLASS}`}
            opened={opened}
            onClose={onClose}
            width={440}
            variant="support"
        >
            <SupportContent html={textInfo} loading={isLoading} isCompact={true} />
            {/* Во вкладке «от имени» показа нет: провайдер там инертен. */}
            {screenShare.available && (
                <SupportScreenShareStart
                    sharing={screenShare.active}
                    onStart={(ticketRef) => {
                        // Выбор вкладки — в этом же нажатии, до закрытия окна.
                        void screenShare.start(ticketRef ? { ticketRef } : undefined);
                        onClose();
                    }}
                />
            )}
        </AnchoredDialog>
    );
};

export default SupportDialog;
